import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Button } from './Button';
import { trackAddToCart } from '../utils/metaPixel';
export const PriceSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="oferta" className="py-12 md:py-24 px-4 md:px-6 bg-cream relative overflow-hidden" ref={ref} data-id="element-128">
      {/* Decorative background */}
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/5 rounded-full blur-3xl pointer-events-none" data-id="element-129"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={isInView ? {
        opacity: 1,
        scale: 1
      } : {
        opacity: 0,
        scale: 0.95
      }} transition={{
        duration: 0.8
      }} className="bg-white border border-gold/20 p-6 md:p-16 rounded-sm shadow-luxury text-center" data-id="element-131">
          <div className="space-y-3 md:space-y-4 mb-6 md:mb-10 text-base md:text-xl text-charcoal/60 font-light" data-id="element-132">
            <p className="flex justify-between items-center max-w-sm mx-auto border-b border-beige pb-2" data-id="element-133">
              <span data-id="element-134">Taller presencial:</span> <span data-id="element-135">$150 USD</span>
            </p>
            <p className="flex justify-between items-center max-w-sm mx-auto border-b border-beige pb-2" data-id="element-136">
              <span data-id="element-137">Sesión de terapia:</span> <span data-id="element-138">$60 USD</span>
            </p>
            <p className="flex justify-between items-center max-w-sm mx-auto border-b border-beige pb-2" data-id="element-139">
              <span data-id="element-140">Curso de negocios:</span> <span data-id="element-141">$100 USD</span>
            </p>
            <p className="flex justify-between items-center max-w-sm mx-auto pt-2 font-medium text-charcoal" data-id="element-142">
              <span data-id="element-143">Valor Total:</span>{' '}
              <span className="line-through decoration-red-500/50 decoration-2" data-id="element-144">
                $310 USD
              </span>
            </p>
          </div>

          <div className="mb-6 md:mb-10" data-id="element-145">
            <p className="text-gold font-bold tracking-widest uppercase text-sm mb-3 md:mb-4" data-id="element-146">
              SOLO POR HOY
            </p>
            <p className="text-xl text-charcoal mb-2" data-id="element-147">
              Llévate el sistema completo por una fracción de su valor.
            </p>
            <div className="text-7xl md:text-8xl font-serif font-bold text-brown my-6" data-id="element-148">
              $9.99{' '}
              <span className="text-2xl text-brown/50 font-sans font-light" data-id="element-149">
                USD
              </span>
            </div>
            <p className="text-sm text-charcoal/60 uppercase tracking-wider" data-id="element-150">
              (Pago único. Acceso inmediato para toda la vida)
            </p>
          </div>

          <Button href="https://rutinasimple.com//cart/52299601412377:1" className="w-full md:w-auto text-lg py-5 px-12" onClick={() => trackAddToCart()} data-id="element-151">
            SÍ, QUIERO ACCESO INMEDIATO
          </Button>
        </motion.div>
      </div>
    </section>;
};